export const SET_NOTIFICATION_IS_VISIBLE =
  'PAGE_LAYOUT/SET_NOTIFICATION_IS_VISIBLE'

export const setNotificationIsVisible = (isVisibile) => ({
  type: SET_NOTIFICATION_IS_VISIBLE,
  payload: isVisibile
})
